import React from 'react';

class OverrideEmailValidation extends React.Component {

    constructor(props) {

        super(props);
        this.onChecked = this.onChecked.bind(this);
    }

    onChecked(e) {

        this.props.onChange(e.target.checked);
    }

    render() {

        return (
            <div className="form-check">
              <label className="form-check-label">
                <input type="checkbox" className="form-check-input" checked={this.props.checked} onChange={this.onChecked} />
                Override Email Validation
              </label>
            </div>
        );
    }
}

export default OverrideEmailValidation;
